export default {
  menuList : [
    {
      id: 100,
      text: 'Leaderboard',
      name: 'Leaderboard',
      subMenu: [
        {
          id: 101,
          parentId: 100,
          text: 'LLM',
          name: 'LLM',
          path: '/leaderboard-llm'
        },
        {
          id: 102,
          parentId: 100,
          text: 'Multi-Modality',
          name: 'MultiModality',
          path: '/leaderboard-multimodal'
        }
      ]
    },
    {
      id: 200,
      text: 'RecipeDetail',
      name: 'RecipeDetail',
      subMenu: [
        {
          id: 201,
          parentId: 200,
          text: 'AutoDAN',
          name: 'AutoDAN',
          path: '/recipe-AutoDAN'
        },
        {
          id: 202,
          parentId: 200,
          text: 'Cipher',
          name: 'Cipher',
          path: '/recipe-AutoDAN'
        },
        {
          id: 203,
          parentId: 200,
          text: 'DeepInception',
          name: 'DeepInception',
          path: '/recipe-DeepInception'
        },
        {
          id: 204,
          parentId: 200,
          text: 'GCG',
          name: 'GCG',
          path: '/recipe-GCG'
        },
        {
          id: 205,
          parentId: 200,
          text: 'GPTFuzz',
          name: 'GPTFuzz',
          path: '/recipe-GPTFuzz'
        },
        {
          id: 206,
          parentId: 200,
          text: 'ICA',
          name: 'ICA',
          path: '/recipe-ICA'
        },
        {
          id: 207,
          parentId: 200,
          text: 'JailBroken',
          name: 'JailBroken',
          path: '/recipe-JailBroken'
        },
        {
          id: 208,
          parentId: 200,
          text: 'MultiLingual',
          name: 'MultiLingual',
          path: '/recipe-MultiLingual'
        },
        {
          id: 209,
          parentId: 200,
          text: 'PAIR',
          name: 'PAIR',
          path: '/recipe-PAIR'
        },
        {
          id: 210,
          parentId: 200,
          text: 'ReNeLLM',
          name: 'ReNeLLM',
          path: '/recipe-ReNeLLM'
        },
        {
          id: 211,
          parentId: 200,
          text: 'TAP',
          name: 'TAP',
          path: '/recipe-TAP'
        }
      ]
    },
    {
      id: 300,
      text: 'Document',
      name: 'DocumentView',
      path: '/document'
    }
  ],
  mainTableDb: [{id: 1,
    Model: 'GPT3.5',
    ReNeLLM: '87%',
    GPTFuzz: '86%',
    ICA: '0%',
    AutoDAN: '',
    PAIR: '19%',
    JailBroken: '100%',
    Cipher: '80%',
    DeepInception: '66%',
    MultiLingual: '100%',
    GCG: '12%',
    Avg: '61.1%'},
    {id: 2,
      Model: 'GPT4',
      ReNeLLM: '38%',
      GPTFuzz: '0%',
      ICA: '1%',
      AutoDAN: '',
      PAIR: '12%',
      JailBroken: '58%',
      Cipher: '75%',
      DeepInception: '35%',
      MultiLingual: '63%',
      GCG: '0%',
      Avg: '31.3%'},
    {id: 3,
      Model: 'Llama2-7B-chat',
      ReNeLLM: '31%',
      GPTFuzz: '46%',
      ICA: '0%',
      AutoDAN: '25%',
      PAIR: '52%',
      JailBroken: '6%',
      Cipher: '61%',
      DeepInception: '8%',
      MultiLingual: '2%',
      GCG: '46%',
      Avg: '27.7%'},
    {id: 4,
      Model: 'Llama2-13B-chat',
      ReNeLLM: '69%',
      GPTFuzz: '42%',
      ICA: '0%',
      AutoDAN: '',
      PAIR: '8%',
      JailBroken: '4%',
      Cipher: '90%',
      DeepInception: '0%',
      MultiLingual: '0%',
      GCG: '46%',
      Avg: '28.8%'},
    {id: 5,
      Model: 'Vicuna7B',
      ReNeLLM: '77%',
      GPTFuzz: '100%',
      ICA: '52%',
      AutoDAN: '100%',
      PAIR: '100%',
      JailBroken: '100%',
      Cipher: '57%',
      DeepInception: '29%',
      MultiLingual: '94%',
      GCG: '94%',
      Avg: '80.3%'},
    {id: 6,
      Model: 'Vicuna13B',
      ReNeLLM: '87%',
      GPTFuzz: '100%',
      ICA: '80%',
      AutoDAN: '100%',
      PAIR: '100%',
      JailBroken: '100%',
      Cipher: '61%',
      DeepInception: '17%',
      MultiLingual: '100%',
      GCG: '94%',
      Avg: '83.9%'},
    {id: 7,
      Model: 'ChatGLM3',
      ReNeLLM: '86%',
      GPTFuzz: '100%',
      ICA: '54%',
      AutoDAN: '100%',
      PAIR: '96%',
      JailBroken: '95%',
      Cipher: '32%',
      DeepInception: '33%',
      MultiLingual: '100%',
      GCG: '34%',
      Avg: '73.0%'},
    {id: 8,
      Model: 'Qwen-7B-chat',
      ReNeLLM: '70%',
      GPTFuzz: '100%',
      ICA: '37%',
      AutoDAN: '100%',
      PAIR: '82%',
      JailBroken: '100%',
      Cipher: '34%',
      DeepInception: '58%',
      MultiLingual: '99%',
      GCG: '48%',
      Avg: '72.8%'},
    {id: 9,
      Model: 'Intern7B',
      ReNeLLM: '67%',
      GPTFuzz: '100%',
      ICA: '23%',
      AutoDAN: '100%',
      PAIR: '96%',
      JailBroken: '100%',
      Cipher: '85%',
      DeepInception: '36%',
      MultiLingual: '99%',
      GCG: '10%',
      Avg: '71.6%'},
    {id: 10,
      Model: 'Mistral',
      ReNeLLM: '90%',
      GPTFuzz: '100%',
      ICA: '67%',
      AutoDAN: '100%',
      PAIR: '94%',
      JailBroken: '100%',
      Cipher: '60%',
      DeepInception: '40%',
      MultiLingual: '100%',
      GCG: '82%',
      Avg: '83.3%'},
    {id: 11,
      Model: 'Avg',
      ReNeLLM: '70%',
      GPTFuzz: '77%',
      ICA: '31%',
      AutoDAN: '89%',
      PAIR: '66%',
      JailBroken: '76%',
      Cipher: '64%',
      DeepInception: '32%',
      MultiLingual: '76%',
      GCG: '47%',
      Avg: ''}],
  asideMenu:[
    {
      id: 's100',
      text: 'Get Started',
      subMenu: [
        {
          id: 's101',
          parentId: 's100',
          text: 'Installation',
        },
        {
          id: 's102',
          parentId: 's100',
          text: 'Dataset Preparation'
        },
        {
          id: 's103',
          parentId: 's100',
          text: 'Quick Start'
        },
        {
          id: 's104',
          parentId: 's100',
          text: 'FAQ'
        }
      ]
    },
    {
      id: 's200',
      text: 'User Guides',
      subMenu: [
        {
          id: 's201',
          parentId: 's200',
          text: 'Overview',
        },
        {
          id: 's202',
          parentId: 's200',
          text: 'Learn About Config'
        },
        {
          id: 's203',
          parentId: 's200',
          text: 'Configure Datasets'
        },
        {
          id: 's204',
          parentId: 's200',
          text: 'Prepare Models'
        },
        {
          id: 's205',
          parentId: 's200',
          text: 'Efficient Evaluation',
        },
        {
          id: 's206',
          parentId: 's200',
          text: 'Task Execution and Monitoring'
        },
        {
          id: 's207',
          parentId: 's200',
          text: 'Metric Calculation'
        },
        {
          id: 's208',
          parentId: 's200',
          text: 'Results Summary'
        }
      ]
    },
    {
      id: 's300',
      text: 'Prompt',
      subMenu: [
        {
          id: 's301',
          parentId: 's300',
          text: 'Prompt Overview',
        },
        {
          id: 's302',
          parentId: 's300',
          text: 'Prompt Template'
        },
        {
          id: 's303',
          parentId: 's300',
          text: 'Meta Template'
        },
        {
          id: 's304',
          parentId: 's300',
          text: 'Chain of Thought'
        }
      ]
    },
    {
      id: 's400',
      text: 'Advanced Guides',
      subMenu: [
        {
          id: 's401',
          parentId: 's400',
          text: 'Add a dataset',
        },
        {
          id: 's402',
          parentId: 's400',
          text: 'Custom Dataset Tutorial'
        },
        {
          id: 's403',
          parentId: 's400',
          text: 'Add a Model'
        },
        {
          id: 's404',
          parentId: 's400',
          text: 'Evaluation with LMDeploy'
        },
        {
          id: 's405',
          parentId: 's400',
          text: 'Evaluation with Lightllm',
        },
        {
          id: 's406',
          parentId: 's400',
          text: 'Code Evaluation Tutorial'
        },
        {
          id: 's407',
          parentId: 's400',
          text: 'Code Evaluation Docker Tutorial'
        },
        {
          id: 's408',
          parentId: 's400',
          text: 'Multi-modality Evaluation'
        },
        {
          id: 's409',
          parentId: 's400',
          text: 'Prompt Attack',
        },
        {
          id: 's410',
          parentId: 's400',
          text: 'Long Context Evaluation Guidance'
        },
        {
          id: 's411',
          parentId: 's400',
          text: 'Subjective Evaluation Guidance'
        },
        {
          id: 's412',
          parentId: 's400',
          text: 'CircularEval'
        },
        {
          id: 's413',
          parentId: 's400',
          text: 'Data Contamination Assessment',
        },
        {
          id: 's414',
          parentId: 's400',
          text: 'Needle In A Haystack Experiment Evaluation'
        }
      ]
    },
    {
      id: 's500',
      text: 'Tools',
      subMenu: [
        {
          id: 's501',
          parentId: 's500',
          text: 'Useful Tools',
        }
      ]
    },
    {
      id: 's600',
      text: 'Notes',
      subMenu: [
        {
          id: 's601',
          parentId: 's600',
          text: 'Contributing to OpenCompass'
        }
      ]
    }
  ]
};
